import { ReactNode, useMemo, useState } from "react";
import { clsx } from "clsx";

import { ThemeContext } from "@/shared/lib/contexts/ThemeContext";
import { AppTheme } from "@/shared/const/storageKeys";
import { useUser } from "@/entities/Auth";
import { Theme } from "@/shared/lib/hooks/useTheme";
import { UserRole } from "@/shared/const/userRole";

const defaultTheme = (localStorage.getItem(AppTheme) as Theme) || Theme.Light;

interface ThemeProviderProps {
  children: ReactNode;
  initialTheme?: Theme;
}

export const ThemeProvider = ({ children, initialTheme }: ThemeProviderProps) => {
  const user = useUser();

  const [theme, setTheme] = useState<Theme>(initialTheme || defaultTheme);

  const isEnabled = user?.role === UserRole.Customer;

  const defaultProps = useMemo(() => {
    return {
      theme: isEnabled ? theme : Theme.Light,
      setTheme,
    };
  }, [theme, isEnabled]);

  return (
    <div className={clsx("app", {}, [isEnabled ? theme : Theme.Light])}>
      <ThemeContext.Provider value={defaultProps}>{children}</ThemeContext.Provider>
    </div>
  );
};
